
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square12 = createMeisterIcons("square-12", [["path",{"fill":"currentColor","d":"M3.75 7A3.26 3.26 0 0 1 7 3.75h4.25v16.5H7A3.26 3.26 0 0 1 3.75 17zm9 13.25H17A3.26 3.26 0 0 0 20.25 17V7A3.26 3.26 0 0 0 17 3.75h-4.25zM7 2.25A4.76 4.76 0 0 0 2.25 7v10A4.76 4.76 0 0 0 7 21.75h10A4.76 4.76 0 0 0 21.75 17V7A4.76 4.76 0 0 0 17 2.25z","key":"7a653f427cad8883bea754561c201efbf8703b13","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square12
  